type WakeLockSentinelLike = { release: () => Promise<void> };

let lock: WakeLockSentinelLike | null = null;

export async function acquireScreenWake(): Promise<void> {
  try {
    const nav = navigator as Navigator & { wakeLock?: { request: (type: 'screen') => Promise<WakeLockSentinelLike> } };
    if (nav.wakeLock?.request) {
      lock = await nav.wakeLock.request('screen');
    }
  } catch {
    /* user denied or not supported */
  }
}

export async function releaseScreenWake(): Promise<void> {
  try {
    await lock?.release();
  } catch {
    /* ignore */
  }
  lock = null;
}
